import { forwardRef, createContext, useMemo } from 'react';
import { cn } from '../../lib/styles';
import { ChildPositionProvider } from '@page/core/hooks/dom/useChildPosition';

export interface TimelineProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  /**
   * Size of the bullets in pixels.
   * @default 16
   */
  bulletSize?: number;
}

type TimelineContextValue = Pick<TimelineProps, 'bulletSize'>;

export const TimelineContext = createContext<TimelineContextValue | null>(null);

/**
 * Timeline component for displaying chronological events
 */
export const Timeline = forwardRef<HTMLDivElement, TimelineProps>(
  ({ className, children, bulletSize = 16, ...props }, ref) => {
    const contextValue = useMemo(() => ({ bulletSize }), [bulletSize]);
    return (
      <div ref={ref} className={cn('flex flex-col', className)} {...props}>
        <TimelineContext.Provider value={contextValue}>
          <ChildPositionProvider>{children}</ChildPositionProvider>
        </TimelineContext.Provider>
      </div>
    );
  },
);

Timeline.displayName = 'Timeline';
